import { c as _c } from "react/compiler-runtime";
import { ListingCardShell, ListingCardImage, ListingCardContent, CategoryTags } from "../parts";
import type { VisualType } from "@/lib/types";
export function ArticleCard(t0) {
  const $ = _c(19);
  const {
    visual,
    title,
    href,
    categories,
    date,
    className,
    imageSizes,
    imageCropAspect
  } = t0;
  let t1;
  if ($[0] !== categories) {
    t1 = <CategoryTags categories={categories} />;
    $[0] = categories;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== imageCropAspect || $[3] !== imageSizes || $[4] !== t1 || $[5] !== visual) {
    t2 = <ListingCardImage visual={visual} overlay={t1} sizes={imageSizes} cropAspect={imageCropAspect} />;
    $[2] = imageCropAspect;
    $[3] = imageSizes;
    $[4] = t1;
    $[5] = visual;
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  let t3;
  if ($[7] !== title) {
    t3 = <p className="w-full typography-component-sm-medium text-text-primary desktop:typography-component-md-medium">{title}</p>;
    $[7] = title;
    $[8] = t3;
  } else {
    t3 = $[8];
  }
  let t4;
  if ($[9] !== date) {
    t4 = date && <p className="typography-body-sm-regular text-text-secondary">{date}</p>;
    $[9] = date;
    $[10] = t4;
  } else {
    t4 = $[10];
  }
  let t5;
  if ($[11] !== t3 || $[12] !== t4) {
    t5 = <ListingCardContent gapClass="gap-2">{t3}{t4}</ListingCardContent>;
    $[11] = t3;
    $[12] = t4;
    $[13] = t5;
  } else {
    t5 = $[13];
  }
  let t6;
  if ($[14] !== className || $[15] !== href || $[16] !== t2 || $[17] !== t5) {
    t6 = <ListingCardShell href={href} gapClass="gap-3 desktop:gap-4" className={className}>{t2}{t5}</ListingCardShell>;
    $[14] = className;
    $[15] = href;
    $[16] = t2;
    $[17] = t5;
    $[18] = t6;
  } else {
    t6 = $[18];
  }
  return t6;
}